import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  input,
  Input,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FormsModule, NgControl, ReactiveFormsModule } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatFormFieldAppearance } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { BrandService } from 'brand';
import { SvgComponent } from 'icon';
import { TranslatePipe } from 'translate';
import { AutofocusDirective } from '../autofocus.directive';
import { FormFieldBaseComponent } from '../form-field-base.component';

@Component({
  selector: 'lib-input-form-field',
  templateUrl: './input-form-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    MatInputModule,
    FormsModule,
    AutofocusDirective,
    ReactiveFormsModule,
    NgxMaskDirective,
    SvgComponent,
    TranslatePipe,
  ],
  providers: [provideNgxMask()],
})
export class FormFieldComponent extends FormFieldBaseComponent {
  protected brandService = inject(BrandService);
  public ngControl = inject(NgControl, { optional: true, self: true });
  @Input() public autoFocus: boolean;
  @Input() public loading = false;
  @Input() public isBackendValid = true;
  @Input() public autocomplete = '';
  @Input() public theme: ThemePalette = 'primary';
  @Input() public mask?: string;
  @Input() public showMaskedInput = false;
  public readonly maskCustomPatterns: NgxMaskDirective['patterns'] = input();
  public readonly maskInputTransformFn: NgxMaskDirective['inputTransformFn'] = input((value: string | number) => {
    return value;
  });
  @Input() public maxLength: number;
  @Input() public showHidePassword = false;
  public appearance = input<MatFormFieldAppearance>('outline');
  public showPassword: boolean;
  @ViewChild('inputEl') public inputEl: ElementRef;
  @ViewChild('maskedInput') public maskedInput: ElementRef;
  public inputOnFocus = false;

  public focus() {
    if (!this.mask) {
      return this.inputEl.nativeElement.focus();
    }
    return this.maskedInput.nativeElement.focus();
  }

  public dispatch(input: HTMLInputElement, event: string, evt?: Event) {
    input.dispatchEvent(new Event(event));
    if (event === 'input') {
      this._onInput(evt);
    }
    if (event === 'blur') {
      this.inputOnFocus = false;
      this._onBlur();
    }
    if (event === 'focus') {
      this.inputOnFocus = true;
      this._onFocus();
    }
  }

  public togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
    this.type = this.showPassword ? 'text' : 'password';
  }
}
